import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const base = process.env.REACT_APP_API_URL;

function authHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}

export default function useAddresses() {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem('token')) {
      setAddresses([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${base}/api/addresses`, { headers: authHeaders() });
      setAddresses(res.data.addresses);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load addresses');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const createAddress = useCallback(async (payload) => {
    const res = await axios.post(`${base}/api/addresses`, payload, { headers: authHeaders() });
    await refresh();
    return res.data.address;
  }, [refresh]);

  const updateAddress = useCallback(async (id, payload) => {
    const res = await axios.patch(`${base}/api/addresses/${id}`, payload, { headers: authHeaders() });
    await refresh();
    return res.data.address;
  }, [refresh]);

  const deleteAddress = useCallback(async (id) => {
    await axios.delete(`${base}/api/addresses/${id}`, { headers: authHeaders() });
    await refresh();
  }, [refresh]);

  const setDefaultAddress = useCallback(async (id) => {
    return updateAddress(id, { is_default: true });
  }, [updateAddress]);

  return {
    addresses,
    loading,
    error,
    refresh,
    createAddress,
    updateAddress,
    deleteAddress,
    setDefaultAddress,
  };
}
